import axios from "axios";
import { useContext, useState } from "react";
import AuthContext from "../context/AuthContext";

function useAxiosRequests() {
    const [error, setError] = useState(null);
      const { logout } = useContext(AuthContext);

    const sendRequest = async ({ method, url, body = null, config = {} }) => {
        setError(null); 

        const user = JSON.parse(localStorage.getItem("user"))
        const token = user?.token
        const isMultipart = body instanceof FormData;
        
        const headers = {
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            "Content-Type": isMultipart ? "multipart/form-data" : "application/json",
            ...config.headers,
        };

        try {
            const response = await axios({
                method,
                url,
                data: body,
                headers,
                ...config, 
            });
            return response.data;
        } catch (err) {
            const status = err.response?.status;
            const message = err.response?.data?.message || err.message;
            if (status === 401 && message.toLowerCase().includes("token")) {
                logout();
                window.location.href = "/login"; 
            }
            setError(message);
            return null;
        }
    };

    return { sendRequest, error };
}

export default useAxiosRequests;